!function() {
  var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {}, e = {}, i = {}, n = t.parcelRequire5f74;
  null == n && ((n = function(t) {
    if (t in e) return e[t].exports;
    if (t in i) {
      var n = i[t];
      delete i[t];
      var s = {
        id: t,
        exports: {}
      };
      return e[t] = s, n.call(s.exports, s, s.exports), s.exports;
    }
    var d = new Error("Cannot find module '" + t + "'");
    throw d.code = "MODULE_NOT_FOUND", d;
  }).register = function(t, e) {
    i[t] = e;
  }, t.parcelRequire5f74 = n), (0, n.register)("cJzMp", function(t, e) {
    var i, n, s, d;
    i = t.exports, n = "createLogger", s = function() {
      return c;
    }, Object.defineProperty(i, n, {
      get: s,
      set: d,
      enumerable: !0,
      configurable: !0
    });
    const a = "mbf_debug", r = [ "lifecycle", "events", "network", "ui", "animation", "errors" ];
    function o() {
      const t = {};
      return r.forEach(e => t[e] = !0), {
        enabled: !1,
        categories: t,
        files: {}
      };
    }
    "undefined" != typeof window && function() {
      try {
        const t = localStorage.getItem(a);
        if (!t) return o();
        const e = JSON.parse(t), i = o();
        return i.enabled = !!e.enabled, e.categories && "object" == typeof e.categories && Object.keys(i.categories).forEach(t => {
          t in e.categories && (i.categories[t] = !!e.categories[t]);
        }), e.files && "object" == typeof e.files && (i.files = e.files), i;
      } catch {
        return o();
      }
    }();
    const c = () => () => {};
  });
  var s = n("cJzMp");
  (() => {
    if (customElements.get("swish-wishlist-button")) return;
    const t = "Modal-SwishAuth", e = (0, s.createLogger)("swish-wishlist-button");
    customElements.define("swish-wishlist-button", class extends HTMLElement {
      static get observedAttributes() {
        return [ "data-added", "data-pending" ];
      }
      get productId() {
        return Number(this.dataset.productId);
      }
      get variantId() {
        return this.dataset.variantId ? Number(this.dataset.variantId) : null;
      }
      get isAdded() {
        return "true" === this.getAttribute("data-added");
      }
      connectedCallback() {
        this.setAttribute("role", "button"), this.setAttribute("tabindex", "0"), this.onClick = () => this.toggle(), 
        this.onKeydown = t => {
          "Enter" !== t.key && " " !== t.key || (t.preventDefault(), this.toggle());
        }, this.onWishlistChanged = () => this.syncState(), this.onVariantChange = t => {
          const e = t.target;
          if (!(e instanceof HTMLElement)) return;
          if (Number(e.dataset?.productId) !== this.productId) return;
          const i = t.detail?.variant?.id;
          i && (this.dataset.variantId = String(i));
        }, this.addEventListener("click", this.onClick), this.addEventListener("keydown", this.onKeydown), 
        document.addEventListener("swish:wishlistChanged", this.onWishlistChanged), this.closest(".section--main-product") && document.addEventListener("variant:change", this.onVariantChange), 
        this.syncState();
      }
      disconnectedCallback() {
        this.removeEventListener("click", this.onClick), this.removeEventListener("keydown", this.onKeydown), 
        document.removeEventListener("swish:wishlistChanged", this.onWishlistChanged), document.removeEventListener("variant:change", this.onVariantChange);
      }
      attributeChangedCallback(t, e, i) {
        e !== i && "data-added" === t && (this.setAttribute("aria-pressed", String(this.isAdded)), 
        this.setAttribute("aria-label", (this.isAdded ? window.MBF?.strings?.swish?.remove : window.MBF?.strings?.swish?.add) || ""));
      }
      syncState() {
        this.hasAttribute("data-pending") || this.setAttribute("data-added", String(window.MBF?.swish?.hasProduct(this.productId) || !1));
      }
      openAuthModal() {
        const i = document.getElementById(t);
        e("events", "openAuthModal", {
          modalId: t,
          found: Boolean(i)
        }), i && (i.checked = !0, i.dispatchEvent(new Event("change", {
          bubbles: !0
        })));
      }
      savePendingItem() {
        try {
          const t = {
            productId: this.productId,
            variantId: this.variantId,
            at: Date.now()
          };
          localStorage.setItem("swish:pending-item:v1", JSON.stringify(t)), e("events", "savePendingItem", t);
        } catch (t) {
          e("errors", "savePendingItem storage write failed", t);
        }
      }
      async toggle() {
        if (this.hasAttribute("data-pending")) return;
        if (!window.MBF?.customer?.id) return e("lifecycle", "toggle guest branch", {
          productId: this.productId,
          variantId: this.variantId,
          customerId: window.MBF?.customer?.id ?? null
        }), this.savePendingItem(), void this.openAuthModal();
        if (!window.MBF?.swish) return void console.warn("[swish] SDK unavailable");
        this.setAttribute("data-pending", ""), document.dispatchEvent(new CustomEvent("spinner:show", {
          detail: {
            source: "swish-wishlist"
          }
        }));
        const t = this.isAdded;
        try {
          const {added: t} = await window.MBF.swish.toggleProduct(this.productId, this.variantId);
          this.setAttribute("data-added", String(t)), document.dispatchEvent(new CustomEvent(t ? "swish:addToWishlist" : "swish:removeFromWishlist", {
            detail: {
              productId: this.productId,
              variantId: this.variantId
            }
          }));
        } catch (e) {
          console.warn("[swish] toggle failed", e), this.setAttribute("data-added", String(t));
        } finally {
          this.removeAttribute("data-pending"), document.dispatchEvent(new CustomEvent("spinner:hide", {
            detail: {
              source: "swish-wishlist"
            }
          }));
        }
      }
    });
  })();
}();